import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../unsorted/index4.js';
import { setCacheItem, getCacheItem } from './cacheHelpers.js';

function fetchLogoContent(_x) {
  return _fetchLogoContent.apply(this, arguments);
}
function _fetchLogoContent() {
  _fetchLogoContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logo) {
    var localStorageKey, cachedIcon, resp, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          localStorageKey = "logo-".concat(logo);
          _context.next = 3;
          return getCacheItem(localStorageKey);
        case 3:
          cachedIcon = _context.sent;
          if (!cachedIcon) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", cachedIcon);
        case 6:
          _context.prev = 6;
          _context.next = 9;
          return fetch("https://biome.immutable.com/hosted-assets/logos/".concat(logo, ".json"));
        case 9:
          resp = _context.sent;
          _context.next = 12;
          return resp.json();
        case 12:
          data = _context.sent;
          setCacheItem(localStorageKey, data);
          return _context.abrupt("return", data);
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](6);
          console.error("🧬 BIOME (logo) Error 🚨:", _context.t0);
          return _context.abrupt("return", null);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 17]]);
  }));
  return _fetchLogoContent.apply(this, arguments);
}

export { fetchLogoContent };
//# sourceMappingURL=svgHelpers.js.map
